import React from "react"
import { v4 as uuidv4 } from "uuid"
import Tab from "./Tab"

const Tabs = ({ product }) => {
  const { category } = product
  const { tabItems } = category

  return (
    <>{tabItems && tabItems.map((tab) => <Tab key={uuidv4()} tab={tab} />)}</>
  )
}

export default Tabs
